import styled from 'styled-components'

export const MessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 8px;
  overflow-y: auto;
`;

export const ChatBeginText = styled.h1`
  font-size: 10px;
  font-weight: 600;
  color: #666666;
`;